import type { RaygunV2 } from 'raygun4js';
import type { UserData } from 'src/hooks/helper';

export interface RayGunError {
  error?: Error;
  customData?: Record<string, any>;
}

let logger = (message: string, raygunError?: RayGunError) => {
  // eslint-disable-next-line no-console
  console.error(message, raygunError);
};

export let setRaygunUser: (userData: UserData) => void = () => {};

export const setupLogger = ({
  route,
  environment,
}: {
  route: string;
  environment: string;
}) => {
  const { rg4js } = window;
  const raygun: RaygunV2 = rg4js;
  const params = new URLSearchParams(window.location.search);
  const branchName = params.get('v');
  const env = branchName ? branchName : environment;

  const tags = [`environment:${env}`, `route:${route}`];
  if (raygun) {
    raygun('enableCrashReporting', true);
    raygun('options', {
      ignoreAjaxAbort: true,
      ignore3rdPartyErrors: true,
    });
    raygun('enablePulse', true);
    raygun('whitelistCrossOriginDomains', ['seekcdn.com']);
    raygun('withTags', tags);

    logger = (message, raygunError?: RayGunError) => {
      raygun('send', { message, ...raygunError });
    };
    setRaygunUser = ({ id }: UserData) => {
      raygun('setUser', { identifier: String(id) });
    };
  } else {
    // eslint-disable-next-line no-console
    console.error('Raygun not loaded');
  }

  // catch promise unhandled rejections & errors
  window.addEventListener(
    'unhandledrejection',
    (error: PromiseRejectionEvent) => {
      error.preventDefault();

      logger('Unhandled rejection error', {
        customData: { error },
      });
    },
  );
};

export default logger;
